import FavoritesSection from "./comps/FavoritesSection";

export default function Favoritter() {
	return <div className="flex flex-col gap-4">
		<h1 className={'text-center'}>Favoritter</h1>

		{/*<MyFavourites/>*/}

		<FavoritesSection maxPerRow={3}/>

	</div>
}